export const VIDEO_CALL_WAIT = 45000;
